/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState } from "react";
import { Loading } from "./AllReports";
import { Regenerate } from "./DownloadTable";
import fetchHelper from "../../services/fetchHelper";
import savingspinner from "../../assets/esign-ui-icons/saving-ico-white.svg";
import { downloadAsBlob, getSafeIrFilename } from "../../utils/helpers";

const OtherTable = ({ data, initialLoad }) => {
  const [downloadingPreReport, setDownloadingPreReport] = useState(null);

  const downloadReport = async (item, patient) => {
    setDownloadingPreReport(item.id);
    const filename = getSafeIrFilename(patient, item.id);
    const downloadUrl = await getDownloadUrl(item);
    await downloadAsBlob(downloadUrl, `${filename}.pdf`);
    setDownloadingPreReport(null);
  };

  const getDownloadUrl = async (item) => {
    const pdfQueueMicroservice = await fetchHelper.getPdfQueueStatus(item.location.id);
    let extraParams = pdfQueueMicroservice ? `/${item.interrogationStatus}` : "";
    return `/patientmanagement/rest/interrogations/${item.id}/download${extraParams}`;
  };

  return (
    <div className="contentTbl">
      <table className="overview" id="data-table">
        <thead>
          <tr>
            <th>Status</th>
            <th>Last Name, First</th>
            <th>Device MFR</th>
            <th>Device Type</th>
            <th>Date</th>
            <th>Cycle</th>
            <th>Visit #</th>
            <th>Location</th>
            <th>30 Day</th>
            <th>90 Day</th>
            <th>Download</th>
            <th></th>
          </tr>
        </thead>

        {initialLoad ? (
          <Loading />
        ) : data.length > 0 ? (
          <tbody>
            {data.map(({ device, patient, ...item }) => (
              <tr key={item.id}>
                <td>
                  <div className="statusLbl statusLblTealL">{item.interrogationStatus}</div>
                </td>
                <td>
                  {patient?.family}, {patient?.name}
                </td>
                <td>{device?.manufacturerName}</td>
                <td>{device?.deviceType}</td>
                <td>
                  {item?.interrogationDate ? new Date(item?.interrogationDate).toLocaleDateString() : "-"}
                </td>
                <td>
                  <div>-</div>
                </td>
                <td>{item.visitNumber}</td>
                <td>{item.location?.name}</td>
                <td>{item.thirtyDayBillStatus || "-"}</td>
                <td>
                  <span>{item.nintyDayBillStatus || "-"}</span>
                </td>
                <td>
                  <button className="btn btnSuccess" onClick={() => downloadReport(item, patient)}>
                    {downloadingPreReport == item.id ? (
                      <img id="loading-spinner" src={savingspinner} style={{ width: 15 }}></img>
                    ) : (
                      <span style={{ width: 15 }}></span>
                    )}
                    Download
                  </button>
                </td>
                <td>
                  <Regenerate item={item} />
                </td>
              </tr>
            ))}
          </tbody>
        ) : null}
      </table>
      {data.length === 0 && !initialLoad ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 300,
            fontSize: 18,
          }}
        >
          No reports
        </div>
      ) : null}
    </div>
  );
};

export default OtherTable;
